<main class="lang-page">
  <div class="lang-page__brand">
    <sz-brand-block [compact]="true" />
  </div>

  <div class="spec-bar" aria-hidden="true">
    <span class="spec-bar__b"></span>
    <span class="spec-bar__b spec-bar__b--on" style="height: 40%"></span>
    <span class="spec-bar__b spec-bar__b--on" style="height: 60%"></span>
    <span class="spec-bar__b spec-bar__b--hi" style="height: 90%"></span>
    <span class="spec-bar__b spec-bar__b--on" style="height: 70%"></span>
    <span class="spec-bar__b spec-bar__b--on" style="height: 50%"></span>
    <span class="spec-bar__b"></span>
  </div>

  <div class="lang-page__head">
    <div class="lang-page__kicker">{{ 'languagePicker.kicker' | translate }}</div>
    <h1 class="lang-page__title">
      {{ 'languagePicker.titleMain' | translate }}<br />
      <span class="lang-page__accent">{{ 'languagePicker.titleAccent' | translate }}</span>
    </h1>
    <p class="lang-page__sub">{{ 'languagePicker.sub' | translate }}</p>
  </div>

  <ul class="list">
    @for (opt of options; track opt.code) {
      <li>
        <button
          type="button"
          class="lang"
          [class.lang--selected]="isSelected(opt)"
          [class.lang--disabled]="opt.appCode === null"
          [disabled]="opt.appCode === null"
          (click)="pick(opt)">
          <span class="lang__flag" aria-hidden="true">
            @switch (opt.code) {
              @case ('en') {
                <svg viewBox="0 0 30 22">
                  <rect width="30" height="22" fill="#012169" />
                  <path d="M0 0l30 22M30 0L0 22" stroke="#fff" stroke-width="3" />
                  <path d="M0 0l30 22M30 0L0 22" stroke="#C8102E" stroke-width="1.5" />
                  <path d="M15 0v22M0 11h30" stroke="#fff" stroke-width="4" />
                  <path d="M15 0v22M0 11h30" stroke="#C8102E" stroke-width="2.5" />
                </svg>
              }
              @case ('pl') {
                <svg viewBox="0 0 30 22">
                  <rect width="30" height="11" fill="#fff" />
                  <rect y="11" width="30" height="11" fill="#dc143c" />
                </svg>
              }
              @case ('de') {
                <svg viewBox="0 0 30 22">
                  <rect width="30" height="7.33" fill="#000" />
                  <rect y="7.33" width="30" height="7.33" fill="#dd0000" />
                  <rect y="14.67" width="30" height="7.33" fill="#ffce00" />
                </svg>
              }
              @case ('fr') {
                <svg viewBox="0 0 30 22">
                  <rect width="10" height="22" fill="#002395" />
                  <rect x="10" width="10" height="22" fill="#fff" />
                  <rect x="20" width="10" height="22" fill="#ed2939" />
                </svg>
              }
              @case ('cs') {
                <svg viewBox="0 0 30 22">
                  <rect width="30" height="11" fill="#fff" />
                  <rect y="11" width="30" height="11" fill="#d7141a" />
                  <polygon points="0,0 15,11 0,22" fill="#11457e" />
                </svg>
              }
            }
          </span>
          <span class="lang__body">
            <span class="lang__name">{{ opt.label }}</span>
            <span class="lang__native">{{ opt.native }}</span>
          </span>
          <span class="lang__code-pill">{{ opt.code }}</span>
          <span class="lang__check" aria-hidden="true">
            @if (isSelected(opt)) {
              <sz-icon name="check" [size]="14" />
            }
          </span>
        </button>
      </li>
    }
  </ul>

  <button type="button" class="cta cta--primary" (click)="confirm()">
    <span>{{ 'languagePicker.continueCta' | translate: { lang: selectedLabel() } }}</span>
    <sz-icon name="arrow-right" [size]="16" />
  </button>
</main>
